'use strict';

/**
 * @generated SignedSource<<4ace78862db531f4b10f6825251dee73>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cartId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "channel"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "limit"
        }
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "cartId",
                    "variableName": "cartId"
                },
                {
                    "kind": "Variable",
                    "name": "channel",
                    "variableName": "channel"
                },
                {
                    "kind": "Variable",
                    "name": "limit",
                    "variableName": "limit"
                }
            ],
            "concreteType": "StoreStockResponse",
            "kind": "LinkedField",
            "name": "storeStock",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "availability",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "ClickAndCollectOptionQuery",
            "selections": (v1 /*: any*/),
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "ClickAndCollectOptionQuery",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "4216a1b55c087f5615307d248abdcf75",
            "id": null,
            "metadata": {},
            "name": "ClickAndCollectOptionQuery",
            "operationKind": "query",
            "text": "query ClickAndCollectOptionQuery(\n  $cartId: String!\n  $channel: CartChannel!\n  $limit: Int!\n) {\n  storeStock(cartId: $cartId, channel: $channel, limit: $limit) {\n    availability\n  }\n}\n"
        }
    };
})();
node.hash = "a0974b85ef29aea6c03537dc7165f541";

module.exports = node;
